import React from 'react'
import PropTypes from 'prop-types'
import { dataProps } from '@ds/react-utils'
import { useThemeStyles } from '../../../theming'
import styles from './styles'

export interface HeaderCenterProps {
  /**
   * Children in the middle of the Header.
   */
  children: React.ReactNode
  /**
   * Accepts custom data attributes.
   */
  'data-.*'?: string
  'data-qa'?: string
}

export function HeaderCenter({ children, ...restProps }: HeaderCenterProps) {
  const sx = useThemeStyles(styles)

  return (
    <div {...dataProps(restProps)} css={sx.default}>
      {children}
    </div>
  )
}

HeaderCenter.propTypes = {
  children: PropTypes.node.isRequired,
}

HeaderCenter.displayName = 'Header.Center'
